var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var OrganisationController = /** @class */ (function () {
    function OrganisationController() {
    }
    /*****************************************************************************************************
        * Is using route "api/organisation/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {string[]}
    ******************************************************************************************************/
    OrganisationController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/organisation/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return OrganisationController;
}());
export { OrganisationController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=OrganisationController.js.map